module.exports = __webpack_public_path__ + "static/media/verisFooterIcon.e2725b43.svg";